module.exports = __webpack_public_path__ + "static/gmail-logo-light-9137c789106462e4fa40bd994b17b68a.png";